module.exports = {
    routes: [
        {
            path: '/blog/',
            name: 'blog',
            component: require('./pages/Landing').default,
        },
        {
            path: '/blog/kategori/:slug',
            name: 'blog.category',
            component: require('./pages/Category').default,
        },
        {
            path: '/blog/tag/:slug',
            name: 'blog.tag',
            component: require('./pages/TagList').default,
        },
        {
            path: '/blog/:slug',
            name: 'blog.post',
            component: require('./pages/SinglePost').default,
        },
    ],
};



// WEBPACK FOOTER //
// ./src/taskflex/blog/routes.js